import React from 'react';
import styled, { css } from 'react-emotion';
import PropTypes from 'prop-types';
import withMedia from '~/modules/core/utils/mediaHelpers/withMedia';

import Icon from '~/modules/coreUI/components/basic/Icon';
import { cssMediaMax } from '~/modules/core/utils/cssHelpers/cssMedia';
import {
  ShopHeaderLabel,
} from '~/modules/ecommerceShops/components/basic/Labels';
import { Row } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';
import Spacer from '~/modules/coreUI/components/layouts/helpers/Spacer';
import withDirection from '~/modules/core/utils/mediaHelpers/withDirection';

export const HeaderIcon = withDirection(styled(Icon)`
  ${props => (props.direction === 'rtl'
    && css`
        transform: rotate(-90deg);
      `
  )}
  color: ${props => props.theme.colors.labels.normal};
  font-size: ${props => props.theme.fonts.sizes.large + 1}px;
  ${props => cssMediaMax.tablet`
    margin-right: ${props.theme.paddings.xSmall + 1}px;
    font-size: ${props.theme.fonts.sizes.large - 1}px;
  `};
`);

const Phone = styled(Row)`
  flex-wrap: wrap;
`;

const Link = styled.a`
  color: ${props => props.theme.colors.labels.emphasized};
  font-size: ${props => props.theme.fonts.sizes.medium}px;
  white-space: nowrap;
  ${props => cssMediaMax.xsmall`
    font-size: ${props.theme.fonts.sizes.xSmall}px;
  `} &&:hover {
    color: ${props => props.theme.colors.labels.emphasized};
  }
`;

const PhoneContainer = styled(Row)`
  ${cssMediaMax.mobile`
    align-items: flex-start;
  `};
`;

const PhoneEntry = ({ phone, media }) => (media.maxMobile
  ? (
    <Link href={`tel:${phone.code}${phone.number}`} key={phone.number}>
      {`+${phone.code} ${phone.number} `}
    </Link>
  ) : (
    <ShopHeaderLabel
      key={phone.number}
    >
      {`+${phone.code} ${phone.number} `}
    </ShopHeaderLabel>
  ));

const Telephone = ({ entries, media }) => entries
  && (
  <PhoneContainer fullWidth spaceBetween={0.9}>
    <HeaderIcon className="el-icon el-icon-phone" />
    <Phone fullWidth spaceBetween={0.5}>
      {entries.map((entry, index) => (
        <React.Fragment key={entry.number}>
          <PhoneEntry phone={entry} key={entry.number} media={media} />
          {index < entries.length - 1
            && (
            <React.Fragment>
              <Spacer />
              <span> / </span>
            </React.Fragment>
            )}
        </React.Fragment>
      ))}
    </Phone>
  </PhoneContainer>
  );

PhoneEntry.propTypes = {
  phone: PropTypes.objectOf(PropTypes.string).isRequired,
  media: PropTypes.shape({}).isRequired,
};

Telephone.propTypes = {
  entries: PropTypes.arrayOf(PropTypes.object).isRequired,
  media: PropTypes.shape({}).isRequired,
};

export default withMedia(Telephone);
